import {Route, Routes} from 'react-router-dom';

import {RequireOnboarded} from '../RequireOnboarded';
import {RequireViewer} from '../RequireViewer';
import type {Surface} from '../surface';
import {CLILoginPage} from './CLILoginPage';
import {CLILoginCanceledPage, CLILoginSuccessPage} from './CLILoginResultPage';
import {
  CLI_LOGIN_CANCELED_PATH,
  CLI_LOGIN_PATH,
  CLI_LOGIN_SUCCESS_PATH,
} from './paths';

/** The CLI's pages, rendered on Forge without the shell header. */
export const CLILoginRoutes = ({
  origins,
}: {
  origins?: Partial<Record<Surface, string>>;
}) => (
  <Routes>
    <Route
      path={CLI_LOGIN_PATH}
      element={
        <RequireOnboarded origins={origins}>
          <RequireViewer origins={origins}>
            <CLILoginPage origins={origins} />
          </RequireViewer>
        </RequireOnboarded>
      }
    />
    <Route path={CLI_LOGIN_SUCCESS_PATH} element={<CLILoginSuccessPage />} />
    <Route path={CLI_LOGIN_CANCELED_PATH} element={<CLILoginCanceledPage />} />
  </Routes>
);
